import { render, staticRenderFns } from "./PriceLists.vue?vue&type=template&id=f3c6626e&scoped=true&"
import script from "./PriceLists.vue?vue&type=script&lang=js&"
export * from "./PriceLists.vue?vue&type=script&lang=js&"
import style0 from "./PriceLists.vue?vue&type=style&index=0&id=f3c6626e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c6626e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VMenu,VRow,VSelect})
